import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "tooltip",
    templateUrl: "./tooltip.component.html",
    styleUrls: ["./tooltip.component.scss"],
    standalone: false
})
export class TooltipComponent implements OnInit {
  @Input() text: string;

  ngOnInit(): void {}

  getStringFromHtml(html: string) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.body.textContent || "";
  }
}
